export const MAX_DESCRIPTION_SM_LENGTH = 36;
export const MAX_DESCRIPTION_SM_LENGTH_AB = 40;
